import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';

import { MY_AUTH_APP_TOKEN, MY_AUTH_APP, MY_AUTH_APP_REFRESHTOKEN, UNAUTHORIZED, URL_HOST, LAYOUT_PRIVADO, PATH_LOGIN } from 'const/CommonConst';

export default {
  setupInterceptors: (history) => {

    function getAccessToken(){
      return  window.localStorage.getItem(MY_AUTH_APP_TOKEN) ?? ''
  }
//   function getRefreshToken(){
//     return window.localStorage.getItem(MY_AUTH_APP_REFRESHTOKEN) ?? '';
// }

    // Function that will be called to refresh authorization
// const refreshAuthLogic = failedRequest => axios.post(`${URL_HOST}User/RefreshToken`,
// {
//     "accessToken": getAccessToken(),
//     "refreshToken": getRefreshToken()
//   }).then(tokenRefreshResponse => {

//     if (tokenRefreshResponse.data && tokenRefreshResponse.data.accessToken && tokenRefreshResponse.data.refreshToken && tokenRefreshResponse.data.success)
// {
//     window.localStorage.setItem(MY_AUTH_APP, true);
//     window.localStorage.setItem(MY_AUTH_APP_TOKEN, tokenRefreshResponse.data.accessToken);
//     window.localStorage.setItem(MY_AUTH_APP_REFRESHTOKEN, tokenRefreshResponse.data.refreshToken);

//     failedRequest.response.config.headers['Authorization'] = 'Bearer ' + tokenRefreshResponse.data.accessToken;
//     return Promise.resolve();
// }
// window.localStorage.removeItem(MY_AUTH_APP);
// window.localStorage.removeItem(MY_AUTH_APP_TOKEN);
// window.localStorage.removeItem(MY_AUTH_APP_REFRESHTOKEN);
         
//             window.location = `${LAYOUT_PRIVADO}${PATH_LOGIN}`
//             return;
// });

// createAuthRefreshInterceptor(axios, refreshAuthLogic, {
//   statusCodes: [ UNAUTHORIZED ] // default: [ 401 ]
// });

    axios.interceptors.request.use(
        config => {
          if (!config.headers.Authorization) {
            const accessToken = getAccessToken();
      
            if (accessToken) {
              config.headers.Authorization = `Bearer ${accessToken}`;
            }
          }
          return config;
        },
        error => Promise.reject(error)
      );

    //   axios.interceptors.response.use(response => {
    //     return response;
    //   }, error => {
       
    //     const {status} = error.response;
    //     if (status === UNAUTHORIZED){
    //       logout();
    //        //history.push(`${LAYOUT_AUTH}${ROUTE_LOGIN}`);
    //         window.location = `${LAYOUT_AUTH}${ROUTE_LOGIN}`
    //         return;
    //       }
    //     return Promise.reject(error);
    // });
  },
};
